export const PAGE_ID_BY_KEY = {
  "Home/Personal Loan": "606250be064a9a0010570e50",
  "Transactions/Savings Account": "606250db7659f700167401c4",
  "Credit Card": "606250f15f834a001409de7a",
  Overdraft: "606251005f834a000f6bcc73",
  Other: "6062510d5f834a000e14f50c",
};

export const NEXT_PAGE_IN_FLOW = {
  "606250504f1a60000c2eae26": "606250be064a9a0010570e50", // Switch - Loans
  "606250be064a9a0010570e50": "606250db7659f700167401c4", // Loans
  "606250db7659f700167401c4": "606250f15f834a001409de7a", // Transactions
  "606250f15f834a001409de7a": "606251005f834a000f6bcc73", // Credit Cards
  "606251005f834a000f6bcc73": "6062510d5f834a000e14f50c", // Overdrafts
  "6062510d5f834a000e14f50c": "606251184f1a60001239c7ce", // Other - Submit
};

// Redirect all product pages + submit page to affected products checkbox on prev button clicked
export const PAGE_IDS_TO_REDIRECT_ON_CLICK_PREV = [
  "606250be064a9a0010570e50",
  "606250db7659f700167401c4",
  "606250f15f834a001409de7a",
  "606251005f834a000f6bcc73",
  "6062510d5f834a000e14f50c",
  "606251184f1a60001239c7ce",
];




